import "./src/pages/_index.scss";
import "animate.css";
